/**
 * Head component using Gatsby's built-in Head API
 * 
 * See: https://www.gatsbyjs.org/docs/gatsby-head/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import favicon from '../images/favicon.ico'

function Head({ title, description = ``, lang = `en`, meta = [], noIndex = false }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )
  
  const url = process.env.GATSBY_REPLACEMENT_URL;
  const metaDescription = description || site.siteMetadata.description

  let ogimage, twitterImage;
  ogimage = twitterImage = {'src': '', 'height': '', 'width' : ''}
  if(meta.opengraphImage && meta.opengraphImage.localFile) {
    if( meta.opengraphImage.localFile.childImageSharp)
      ogimage = twitterImage = meta.opengraphImage.localFile.childImageSharp.original;
    else
      ogimage = twitterImage = meta.opengraphImage.localFile.publicURL;
  }

  if(meta.twitterImage && meta.twitterImage.localFile) {
    if( meta.twitterImage.localFile.childImageSharp)
      twitterImage = meta.twitterImage.localFile.childImageSharp.original;
    else
      twitterImage = meta.twitterImage.localFile.publicURL
  }

  return (
    <>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={meta.focuskw} />
      <meta name="article:modified_time" content={meta.opengraphModifiedTime} />
      
      {/* Open Graph */}
      <meta property="og:site_name" content={title} />
      <meta property="og:title" content={meta.opengraphTitle} />
      <meta property="og:description" content={meta.opengraphDescription} />
      <meta property="og:url" content={meta.opengraphUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={url+ogimage.src} />
      <meta property="og:image:width" content={ogimage.width} />
      <meta property="og:image:height" content={ogimage.height} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={site.siteMetadata.author} />
      <meta name="twitter:title" content={meta.twitterTitle || title} />
      <meta name="twitter:description" content={meta.twitterDescription || metaDescription} />
      <meta name="twitter:image" content={url+twitterImage.src} />
      <meta name="twitter:image:width" content={twitterImage.width} />
      <meta name="twitter:image:height" content={twitterImage.height} />
      
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      <link rel="icon" type="image/png" href={favicon} />

      {/* TODO: TEMP GTM TEST - Remove this entire GTM section when testing is complete */}
      {/* Google Tag Manager - Main Script */}
      <script
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-NMHMVQTT');`
        }}
      />

      {/* Google Tag Manager (noscript) Fallback */}
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-NMHMVQTT"
          height="0"
          width="0"
          style={{display:'none', visibility:'hidden'}}
        />
      </noscript>
      {/* End TODO: TEMP GTM TEST */}
    </>
  )
}


Head.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export default Head
